import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { handlePostHogOpenedSharedNugget } from '@backrs_ui/grow-ui/src/pages/Prosper/pages/prosper.util';
import { AppDispatch } from '@backrs_ui/grow-ui/src/redux/store';

import { PostHog } from 'posthog-js';

export const usePreLinkedParams = (dispatch: AppDispatch, postHog: PostHog) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const preLinkedParams = {
      preLinkedNuggetSlug: searchParams.get('nugget'),
      preLinkedScholarshipId: searchParams.get('scholarship'),
      preLinkedCareerPathId: searchParams.get('career-path'),
      preLinkedProfileInternalId: searchParams.get('profile-in'),
      preLinkedProfileExternalId: searchParams.get('profile-ex'),
      preLinkedInternshipId: searchParams.get('internship'),
      preLinkedPostId: searchParams.get('post'),
    } as const;

    handlePostHogOpenedSharedNugget({
      dispatch,
      postHog,
      ...preLinkedParams,
    });
  }, [dispatch, postHog, searchParams]);
};
